// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__1uSsS","content":"Notification_content__2fHsX","button":"Notification_button__3tTHi"};